module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/id/4/5-4212579d168fa7a455b437ef3ffa98be.jpg";